import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'kwo-header-image',
	templateUrl: './header-image.component.html',
	styleUrls: ['./header-image.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderImageComponent implements OnInit {

	@Input() image: string;
	@Input() cover: string;

	constructor() { }

	ngOnInit(): void {
	}

}
